import React from 'react';
import Header from '../../components/Header';

function Coaching() {
  return (
    <Header />
   
  )
}

export default Coaching